// libraries
import React, { useEffect } from 'react'
import clsx from 'clsx'
import dayjs from 'dayjs'

// components
import Section from '/react4xp/components/Section'
import Image from '/react4xp/components/Image'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

export interface SuccessStoriesHeroProps {
	img?: {
		src: string
		srcSmall: string
		srcMedium: string
		srcLarge: string
		alt?: string
		width?: number
		height?: number
	}
	subtitle?: string
	title: string
	date: string
	author: string
	categories: string[]
}

export default function SuccessStoriesHero({
	img,
	subtitle,
	title,
	date,
	author,
	categories
}: SuccessStoriesHeroProps) {
	return (
		<Section
			textColor='text-white'
			className='success-stories-hero'
		>

			<div className='success-stories-hero__bg'>
				{img?.src && (
					<Image
						srcSmall={[`${img.srcSmall}`, 574]} // 570x750
						srcMedium={[`${img.srcMedium}`, 991]} // 1000x1100
						srcLarge={[`${img.srcLarge}`, 1439]} // 1400x900
						src={img.src} // 1900x1000
						alt={img.alt}
						width={img.width}
						height={img.height}
						className='cover'
						priority
					/>
				)}
			</div>

			<div className='grid-container'>
				<div className='grid-row'>

					<div className='c-md-2 success-stories-hero__left'>

						{isNonWhitespaceString(date) && (
							<p className='success-stories-hero__date'>
								{date && dayjs(date).format('MMM DD, YYYY').toUpperCase()}
							</p>
						)}

						{isNonWhitespaceString(author) && (
							<p className='success-stories-hero__author'>
								{author}
							</p>
						)}

						<div className='success-stories-hero__category'>
							{categories?.length ? categories.map((category, i) => (
								<span key={i}>
									{category}
								</span>
							)) : <></>}
						</div>

					</div>

					<div className='c-md-10 c-lg-8 success-stories-hero__right'>

						{isNonWhitespaceString(title) && (
							<h1 className='success-stories-hero__title'>
								{title}
							</h1>
						)}

						{isNonWhitespaceString(subtitle) && (
							<h2 className='success-stories-hero__subtitle'>
								{subtitle}
							</h2>
						)}

					</div>

				</div>


			</div>
		</Section>
	)
}